import {USER_ROLE_MAP, UserRole} from "@/shared/UserRole";
import {MenuLink} from "../_components/layout/MobileMenu/MenuTypes";
import UserInfo from "../types/UserInfo";
import getLegacySitePath from "./getLegacySitePath";
import {hasAnyRole} from "./userUtils";

type LinkPermission = {
	linkData: MenuLink;
	roles?: UserRole[];
	accessKey?: keyof UserInfo;
};

/**
 * Generate the list of links a given user should have in their account menu
 *
 * NOTE: This may or may not become a hook/be integrated into a hook, though I
 *       don't think it's warranted at time of writing.
 * @param user User data obtained from the API
 * @returns an array of links represented as {label, href, id}
 */
const makeAccountMenu: (
	user: UserInfo,
	campusId: string | null
) => MenuLink[] = (user, campusId) => {
	const linkPermissions: LinkPermission[] = [
		{
			linkData: {
				label: "Site Admin",
				href: getLegacySitePath("/site-admin", campusId),
				id: "site-admin",
			},
			accessKey: "has_site_admin_access",
			roles: [USER_ROLE_MAP.ADMIN, USER_ROLE_MAP.FRONT_DESK],
		},
		{
			linkData: {
				label: "Parent Portal",
				href: getLegacySitePath("/parent-portal", campusId),
				id: "parent-portal",
			},
			roles: [USER_ROLE_MAP.PARENT, USER_ROLE_MAP.ADMIN],
		},
		{
			linkData: {
				label: "Gradebook",
				href: getLegacySitePath("/gradebook", campusId),
				id: "gradebook",
			},
			// TODO: Fix gradebook access checking in API
			// This check is slightly tricky since it depends on the campus
			// accessKey: "has_gradebook_access",
			roles: [
				USER_ROLE_MAP.ADMIN,
				USER_ROLE_MAP.INSTRUCTOR,
				USER_ROLE_MAP.SUBSTITUTE_INSTRUCTOR,
				USER_ROLE_MAP.TA,
				USER_ROLE_MAP.FRONT_DESK,
			],
		},
		{
			linkData: {
				label: "Reports",
				href: getLegacySitePath("/reports", campusId),
				id: "reports",
			},
			accessKey: "has_report_access",
		},
		{
			linkData: {
				label: "My Academy",
				href: getLegacySitePath("/my-academy", campusId),
				id: "my-academy",
			},
			roles: [
				USER_ROLE_MAP.ADMIN,
				USER_ROLE_MAP.INSTRUCTOR,
				USER_ROLE_MAP.STUDENT,
				USER_ROLE_MAP.SUBSTITUTE_INSTRUCTOR,
				USER_ROLE_MAP.TA,
				USER_ROLE_MAP.FRONT_DESK,
			],
		},
	];
	if (!user) {
		return [] as MenuLink[];
	}

	const userLinks: MenuLink[] = [];
	for (const {linkData, accessKey, roles = []} of linkPermissions) {
		if (accessKey && user[accessKey]) {
			userLinks.push(linkData);
		} else if (hasAnyRole(user, roles)) {
			userLinks.push(linkData);
		}
	}
	return userLinks;
};

export default makeAccountMenu;
